import script from "./ProceedingsPapers.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceedingsPapers.vue?vue&type=script&setup=true&lang=js"

import "./ProceedingsPapers.vue?vue&type=style&index=0&id=2ba59ec7&lang=scss"

const __exports__ = script;

export default __exports__